import React from "react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-900 px-4 py-10">
      <div className="mx-auto max-w-3xl">
        <h1 className="mb-2 text-3xl font-bold text-white">Terms of Service</h1>
        <p className="mb-8 text-sm text-gray-400">
          Last updated:{" "}
          {new Date().toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>

        <div className="space-y-6 text-gray-300">
          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              1. Agreement to terms
            </h2>
            <p className="text-sm leading-relaxed">
              By accessing or using Cobutler (&quot;Service&quot;), you agree to
              be bound by these Terms of Service. If you do not agree, do not
              use the Service. These terms apply to all visitors, users, and
              others who access or use the Service.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              2. Description of service
            </h2>
            <p className="text-sm leading-relaxed">
              Cobutler provides email-related tools and features, including
              filtering and optional workflows connected to your email account.
              Features may change over time. We do not guarantee uninterrupted
              or error-free operation.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              3. Your account and responsibilities
            </h2>
            <p className="text-sm leading-relaxed">
              You are responsible for maintaining the confidentiality of your
              account credentials and for activity under your account. You agree
              to provide accurate information and to use the Service only in
              compliance with applicable laws and third-party terms (including
              your email provider&apos;s terms).
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              4. Acceptable use
            </h2>
            <p className="text-sm leading-relaxed">
              You may not use the Service to violate any law, harass others,
              send spam, or attempt to gain unauthorized access to systems or
              data. We may suspend or terminate access if we reasonably believe
              you have violated these terms or pose a risk to the Service or
              other users.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              5. Disclaimers and limitation of liability
            </h2>
            <p className="text-sm leading-relaxed">
              The Service is provided &quot;as is&quot; without warranties of
              any kind, express or implied. To the fullest extent permitted by
              law, Cobutler and its suppliers shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages,
              or any loss of profits or data, arising from your use of the
              Service.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              6. Changes
            </h2>
            <p className="text-sm leading-relaxed">
              We may modify these terms from time to time. We will post the
              updated terms on this page and update the &quot;Last updated&quot;
              date. Continued use of the Service after changes constitutes
              acceptance of the revised terms.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-white">
              7. Contact
            </h2>
            <p className="text-sm leading-relaxed">
              Questions about these Terms may be sent to{" "}
              <a
                href="mailto:hello@cobutler.com"
                className="text-blue-400 hover:text-blue-300"
              >
                hello@cobutler.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
